<template lang="pug">
  .profile-links
    router-link(:to="{ name: 'ProfileEdit' }") {{ $t('profile.edit_profile') }}
    span#links-delimeter |
    router-link(:to="{ name: 'ChangePassword' }") {{ $t('profile.change_password') }}
</template>

<script>
  export default {
  }
</script>

<style lang="scss" scoped>
  .profile-links {
    margin-top: 5%;

    a {
      border: 0;
      color: #008bd0;
      font-size: 14px;
      font-weight: 500;
      letter-spacing: 0;
      margin-bottom: 2%;
      padding: 0;
    }

    #links-delimeter {
      margin: 0 5px;
    }
  }
</style>
